import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Breadcrumbs,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import TotalPublisher from "../home/TotalPublisher";
import TotalUser from "../home/totalUser";
import TotalSurveryAttempt from "../home/TotalSurveryAttempt";
import PartnerTotalRevenue from "../home/PartnerTotalRevenue";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import { useDispatch, useSelector } from "react-redux";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import TotalSurveyCompleted from "./TotalSurveyCompleted";
import TotalConversionRate from "./TotalConversionRate";
import { publisherRevenueDetailsAction } from "../../redux/toolkit/publisher/publisherRevenueDetails";
import PublisherDashboardRevenue from "./PublisherDashboardRevenue";
import PublisherDashboardAverageRevenuePerUser from "./PublisherDashboardAverageRevenuePerUser";
import PublisherDashboardWithdrawTransaction from "./PublisherDashboardWithdrawTransaction";
import PublisherDashboardChargeback from "./PublisherDashboardChargeback";
import PublisherTotalUser from "./PublisherTotalUser";
import PublisherSurveyAttempted from "./PublisherSurveyAttempted";
import ActiveUser from "./ActiveUser";
import { getAllAppAction } from "../../redux/toolkit/app/getAllApp";

let breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Home
    </Typography>
  </Stack>
);

const PublisherDashboard = () => {
  const dispatch = useDispatch();
  const [app, setApp] = useState("");

  console.log("app===========================>", app);
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [publisher, setPublisher] = useState(null);
  console.log("publisher=======>", publisher);

  const getPublisherSelector = useSelector((state) => state.getPublisher);
  const { data: publiserData } = getPublisherSelector;

  const { data: publisherRevenue } = useSelector(
    (state) => state.publisherRevenueDetails
  );

  const appsData = useSelector((state) => state.appAllList);
  const { data: app_data } = appsData;

  const dateWiseUser = () => {
    dispatch(
      publisherRevenueDetailsAction({
        publisherId: publisher ,
        startDate:date?.startDate ? dateFormatStartFun(date?.startDate) :null,
        endDate:date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        app_id:app ? app : null
      })
    );
  };

  useEffect(() => {
    dispatch(getPublisherAction({}));
  }, []);

  useEffect(() => {
    dispatch(
      publisherRevenueDetailsAction({
        publisherId: publisher,
        startDate: date?.startDate,
        endDate: date?.endDate,
        app_id:app ? app : null

      })
    );
  }, []);

  useEffect(() => {
    dispatch(getAllAppAction({}));
  }, []);

  return (
    <>
      <Helmet>
        <title>Real Opinion Admin | home</title>
      </Helmet>

      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack direction="row" spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Min Data"
              value={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, startDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Max Data"
              value={date?.endDate}
              minDate={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, endDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <Stack direction="row">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Publisher</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={publisher?.name} // ✅ Correct binding
                  label="Publisher"
                  onChange={(event) => {
                    setPublisher(event.target.value);
                  }}
                >
                  {publiserData?.map((item, i) => (
                    <MenuItem key={i} value={item?._id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>

          <Stack direction="row">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Apps</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Publisher"
                  onChange={(event) => {
                    setApp(event.target.value);
                  }}
                >
                  {app_data?.map((item, i) => (
                    <MenuItem value={item._id}>{item.app_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>

         
          {(date?.startDate && date?.endDate) || publisher || app ? (
            <Button variant="contained" onClick={dateWiseUser}>
              Submit
            </Button>
          ) : null}
        </Stack>

        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid xs={4} item>
            {/* <TotalUser />  */}
            <PublisherTotalUser />
          </Grid>

          <Grid xs={4} item>
            {/* <TotalSurveryAttempt /> */}
            <PublisherSurveyAttempted />
          </Grid>

          <Grid xs={4} item>
            <TotalSurveyCompleted />
          </Grid>
          <Grid xs={4} item>
            <TotalConversionRate />
          </Grid>

          <Grid xs={4} item>
            <PublisherDashboardRevenue />
          </Grid>

          <Grid xs={4} item>
            <PublisherDashboardChargeback />
          </Grid>

          <Grid xs={4} item>
            <PublisherDashboardAverageRevenuePerUser />
          </Grid>

          <Grid xs={4} item>
            <PublisherDashboardWithdrawTransaction />
          </Grid>

          <Grid xs={4} item>
            <ActiveUser />
          </Grid>
        </Grid>
      </Body>
    </>
  );
};

export default PublisherDashboard;
